export enum TipoBaixaTituloEnum {
    Agrupado = 1,
    Individual = 2
}
